import { InMemoryCache } from '@apollo/client';
import { createGraphQLApiProvider } from '@stitch-fix/sf-next';

export const setupCache = () =>
  new InMemoryCache({
    typePolicies: {
      FreestyleSearch: {
        fields: {
          /*
           * Cache results based on q and page variables passed to the getSearchResults query.
           * No need to include the filters and sort since the Graph returns a new `FreestyleSearch.id`
           * value thus creating a separate entry in the cache.
           *
           * source: https://www.apollographql.com/docs/react/pagination/key-args/#setting-keyargs
           */
          shopProductsByPage: {
            keyArgs: ['$q', '$page'],
          },
        },
      },
      FreestyleSearchFilter: {
        fields: {
          /*
           * Cache the filter options based on q and filters variables.
           * Since the filter options are "dynamic", the Graph returns different
           * filter options based on the filters applied to a query, e.g.,
           * - Initial query has four occasion filter options
           * - Client then selects a color option
           * - Follow-up query might then return only two occasion filter options
           *
           * source: https://www.apollographql.com/docs/react/caching/cache-field-behavior/#specifying-key-arguments
           */
          options: {
            keyArgs: ['$q', '$filters'],
          },
        },
      },
      Vision: {
        fields: {
          previousLooks: {
            keyArgs: false,
            merge(existing, incoming) {
              if (!incoming) {
                return existing;
              }

              const existingNodes = existing?.nodes || [];
              const incomingNodes = incoming?.nodes || [];

              return {
                __typename: 'LookConnection',
                nodes: [...existingNodes, ...incomingNodes],
                pageInfo: incoming?.pageInfo ?? existing?.pageInfo ?? null,
              };
            },
          },
        },
      },
      Query: {
        fields: {
          client: {
            merge: true,
          },
        },
      },
    },
  });

export const createProvider = () => {
  const result = createGraphQLApiProvider({ cache: setupCache() });

  if (typeof window !== 'undefined') {
    // @ts-expect-error expose apollo client on window
    window.apolloClient = result.client;
  }

  return result;
};

const { GraphQLApiProvider, client } = createProvider();

const apolloClient = client;

export { GraphQLApiProvider, apolloClient };
